import React, { useEffect, useState } from "react"
import { Container, Card, Col, Row, Spinner } from "reactstrap"
// Redux
import { withRouter, Link } from "react-router-dom"
// actions
import { getCatalogs } from "../../../store/catalogs/menu/actions"
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types'

import Table1 from "../../../components/Common/TableContainer"
import Breadcrumb1 from '../../../components/Common/Breadcrumb'
import { BackButton } from "../../../components/Common/BackButton";
import { SearchBar } from "../../../components/Common/SearchBar";

const CatalogsMenu = (props) => {

  const [searchData, setSearchData] = useState('');

  useEffect(() => {
    dispatch(getCatalogs(`?limit=20&page=0&search=${searchData}`))
  }, [searchData])

  const isLoading = false
  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCatalogs('?limit=20&page=0'));
  }, [])

  const { catalogs, loading, total, currentPage } = useSelector(state => ({
    catalogs: state.catalogsMenu.catalogs,
    total: state.catalogsMenu.total,
    currentPage: state.catalogsMenu.currentPage,
    loading: state.catalogsMenu.loading,
  }));
  // * Redux fin

  const getPagination = (params) => {
    dispatch(getCatalogs(`${params}&search=${searchData}`))
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Categorías',
        accessor: 'category',
        width: 200,
      },
      {
        Header: 'Catálogos',
        Cell: ({ row }) => (
          <div className="text-center">
            {
              (row.original.name === 'Sede')
                ? <span>Región</span>
                : (row.original.name === 'Región')
                  ? <span>Localidad</span>
                  : <span>{row.original.name}</span>
            }
          </div>
        ),
      },
      {
        Header: 'Descripciones',
        accessor: 'description',
        width: 280,
      },
      {
        width: '30',
        Header: "Acciones",
        width: 40,
        Cell: ({ row }) => (
          <div className="text-center">
            <Link to={row.original.url}>
              <button className="btn btn-success mx-1">{"Consultar Catálogo"}</button>
            </Link>
          </div>
        ),
      },
    ],
    []
  )

  const catalog5 = catalogs;

  let newCurrentPage = currentPage - 1;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="" >
          <Col className="col-12" style={{ padding: 20 }}>
            <Card className='' style={{ padding: 50 }}>
              {
                isLoading ?
                  <div className="text-center">
                    <Spinner
                      color="primary"
                      size=""
                    >
                      Cargando...
                    </Spinner>
                  </div> :
                  <div>
                    <div className="d-flex align-items-center justify-content-between">
                      <Breadcrumb1 breadcrumbItem1='catalogsmenu' />
                      <BackButton props={props} />
                    </div>
                    <Row>
                      <SearchBar setSearchData={setSearchData} />
                    </Row>
                    <Table1 currentPage={newCurrentPage} getPagination={getPagination} total={total} loading={loading} props={props} isAddTableBorderStrap columns={columns} data={catalog5} /></div>
              }
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(CatalogsMenu)

CatalogsMenu.propTypes = {
  error: PropTypes.any,
  getCatalogs: PropTypes.func,
}